// extracted by mini-css-extract-plugin
module.exports = {"timer-cta":"WwZQk","Text":"_3L9TE","upcoming-event-timer":"_3m74F","shake":"_1R_m8"};